export const GET_ALL_TYPES = '@@Lookups/GET_ALL_TYPES';
export const GET_ACTIVE_TYPES = '@@Lookups/GET_ACTIVE_TYPES';
export const GET_LOOKUP_TYPES = '@@Lookups/GET_LOOKUP_TYPES';
export const GET_LOOKUPS_BY_TYPE = '@@Lookups/GET_LOOKUPS_BY_TYPE';
export const SELECTED_LOOKUP_TYPE = '@@Lookups/SELECTED_LOOKUP_TYPE';
export const GET_TYPE_BY_NAME = 'GET_TYPE_BY_NAME';
